/* 🤖 this file was generated by svg-to-ts */
export const sbIconsFilter: {
  name: 'filter';
  data: string;
} = {
  name: 'filter',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M17 0H3C1.34 0 0 1.34 0 3v1.17c0 .41.08.82.25 1.2v.06c.14.32.34.61.59.86L7 12.41V19c0 .35.18.67.47.85.16.1.34.15.53.15.16 0 .31-.04.45-.11l4-2c.34-.17.55-.51.55-.89v-4.59l6.12-6.12c.25-.25.45-.54.59-.86v-.06c.18-.38.28-.78.29-1.2V3c0-1.66-1.34-3-3-3m-5.71 11.29c-.19.19-.29.44-.29.71v4.38l-2 1V12c0-.27-.1-.52-.29-.71L3.41 6h13.18zM18 4H2V3c0-.55.45-1 1-1h14c.55 0 1 .45 1 1z"/></svg>`
};
